import Vue from "vue";

class ToastService {
    constructor() {
        this.toasts = [];
        this.container = null;
        this.init();
    }

    init() {
        if (!this.container) {
            this.container = document.createElement("div");
            this.container.id = "toast-container";
            this.container.className = "toast-container";
            document.body.appendChild(this.container);
        }
    }

    show(options) {
        const toastOptions = {
            type: "info",
            title: "",
            message: "",
            duration: 5000,
            autoClose: true,
            ...options
        };

        const id = Date.now() + Math.random();

        const ToastComponent = Vue.extend({
            render(h) {
                return h("toast", {
                    props: {
                        type: toastOptions.type,
                        title: toastOptions.title,
                        message: toastOptions.message,
                        duration: toastOptions.duration,
                        autoClose: toastOptions.autoClose
                    },
                    on: {
                        close: () => this.remove(id)
                    }
                });
            },
            methods: {
                remove(toastId) {
                    this.$el.remove();
                    this.toasts = this.toasts
                        ? this.toasts.filter(toast => toast.id !== toastId)
                        : [];
                }
            }
        });

        const toastInstance = new ToastComponent();
        toastInstance.$mount();

        this.container.appendChild(toastInstance.$el);

        this.toasts.push({
            id,
            instance: toastInstance
        });

        return id;
    }

    success(message, title = "", options = {}) {
        return this.show({
            type: "success",
            message,
            title,
            ...options
        });
    }

    error(message, title = "", options = {}) {
        return this.show({
            type: "error",
            message,
            title,
            ...options
        });
    }

    warning(message, title = "", options = {}) {
        return this.show({
            type: "warning",
            message,
            title,
            ...options
        });
    }

    info(message, title = "", options = {}) {
        return this.show({
            type: "info",
            message,
            title,
            ...options
        });
    }

    remove(id) {
        const toast = this.toasts.find(t => t.id === id);
        if (toast) {
            toast.instance.$destroy();
            toast.instance.$el.remove();
            this.toasts = this.toasts.filter(t => t.id !== id);
        }
    }

    clear() {
        this.toasts.forEach(toast => {
            toast.instance.$destroy();
            toast.instance.$el.remove();
        });
        this.toasts = [];
    }
}

const toastService = new ToastService();

window.toast = toastService;

export default toastService;
